import { UploadCloudIcon } from "lucide-react";

export function ImageInput() {
  return (
    <div className="p-2 w-full">
      <div className="bg-muted/20 flex-1 flex flex-col gap-1 text-center justify-center items-center border border-border border-dashed rounded-md w-full p-4">
        <UploadCloudIcon className="size-4" />
        <span className="text-muted-foreground text-xs font-medium">
          Ajouter des photos
        </span>
        <span className="text-xs text-muted-foreground/80">
          Glissez-déposez une image ou cliquez pour sélectionner un fichier
        </span>
      </div>
    </div>
  );
}
